module.exports = __webpack_public_path__ + "static/media/toque_gracia_logo.8056abfd.svg";